import cn from 'classnames';
import { FC, useState } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { Link } from 'dibs-elements/exports/Link';
import InfoCircle from 'dibs-icons/exports/legacy/InfoCircle';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import InfoCircleFilled from 'dibs-icons/exports/legacy/InfoCircleFilled';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';

// styles
import dibsCss from 'dibs-css';
import styles from './styles/CheckoutMobileCancelationPolicy.scss';

// types
import { CheckoutMobileCancelationPolicy_item$key as Item } from './__generated__/CheckoutMobileCancelationPolicy_item.graphql';

const itemFragment = graphql`
    fragment CheckoutMobileCancelationPolicy_item on Item {
        cancelationPolicy {
            header
            body
            linkData {
                text
                path
            }
        }
    }
`;

export const CheckoutMobileCancelationPolicy: FC<{ item: Item | null }> = ({ item: itemRef }) => {
    const item = useFragment(itemFragment, itemRef);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const Icon = isModalVisible ? InfoCircleFilled : InfoCircle;

    const { cancelationPolicy } = item || {};
    const { header, body, linkData } = cancelationPolicy || {};
    const { text, path } = linkData || {};

    if (!header || !body) {
        return null;
    }

    return (
        <div className={dibsCss.bgShagreen400}>
            <div className={cn(dibsCss.flex, dibsCss.justifyCenter)}>
                <span
                    className={cn(
                        dibsCss.mxXsmall,
                        dibsCss.myXxsmall,
                        dibsCss.sassyFontBodySmallHeavy
                    )}
                >
                    {header}
                </span>
                <Link
                    onClick={() => setIsModalVisible(true)}
                    className={cn(
                        dibsCss.flex,
                        dibsCss.w14px,
                        dibsCss.mrXsmall,
                        dibsCss.itemsCenter
                    )}
                >
                    <Icon className={styles.icon} />
                </Link>
            </div>
            <ModalContainer
                isOpen={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                mobileModalSize="contentHeight"
                animateFromBottom
            >
                <ModalCloseButton onClick={() => setIsModalVisible(false)} />
                <ModalBody>
                    <div
                        className={cn(
                            dibsCss.mxLarge,
                            dibsCss.mbXsmall,
                            dibsCss.textCenter,
                            dibsCss.sassyFontHeaderMedium
                        )}
                    >
                        {header}
                    </div>
                    <span className={dibsCss.sassyFontBody}>
                        {body}{' '}
                        {path && text && (
                            <Link target="_blank" href={path}>
                                {text}
                            </Link>
                        )}
                    </span>
                </ModalBody>
            </ModalContainer>
        </div>
    );
};
